import moment from "moment";

export const handleDueDate = (date) => {
  let diff = moment().diff(moment(date), "days");
  return diff > 0 ? true : false;
};
